
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.276 2h7.45C16.47 2 18 3.424 18 5.864v8.264C18 16.608 16.471 18 13.725 18h-7.45C3.574 18 2 16.608 2 14.128V5.864C2 3.424 3.573 2 6.276 2zm7.208 10.992H6.516a.725.725 0 00-.667.296.583.583 0 000 .672c.142.2.4.32.667.288h6.968c.355-.032.623-.305.623-.624 0-.328-.268-.6-.623-.632zm.694-3.024c0-.344-.311-.625-.694-.625H6.516c-.384 0-.694.281-.694.625s.31.624.694.624h6.968c.383 0 .694-.28.694-.624zM9.867 6.343c0-.343-.311-.623-.695-.623H6.516v.008c-.384 0-.694.28-.694.624s.31.624.694.624h2.656c.384 0 .695-.28.695-.633z","fill":"#94A3B8"}})])
          )
        }
      }
    